import { TenantConfig } from "types/configs";
import { mergeDocument } from "../utility/firestoreManager";
import { AuthProp } from "types/auth";
import { FeatureFlags, FLAG_PREREQUISITES } from "types/featureFlags";

export const isFlagActive = (
  featureName: string,
  tenant: TenantConfig,
): boolean => {
  if (!tenant || !tenant.props || !tenant.props.featureFlags) {
    return false;
  }

  const flag = tenant.props.featureFlags.find(
    (flag) => flag.name === featureName,
  );

  if (flag) {
    return flag.active;
  }

  return false;
};

export const updateFlag = async (
  featureName: string,
  tenant: TenantConfig,
  enabled: boolean,
  auth: AuthProp,
): Promise<void> => {
  const tenantRef = tenant.ref;

  const flagIndex = tenant.props.featureFlags.findIndex(
    (flag) => flag.name === featureName,
  );

  if (flagIndex === -1) {
    console.error(`Feature flag ${featureName} not found.`);
    return;
  }

  const prerequisite = FLAG_PREREQUISITES[featureName as FeatureFlags];

  if (enabled && prerequisite && !isFlagActive(prerequisite, tenant)) {
    console.error(
      `Feature flag ${featureName} requires ${prerequisite} to be active.`,
    );
    return;
  }

  const updateObject = {
    props: {
      featureFlags: [...tenant.props.featureFlags],
    },
  };

  updateObject.props.featureFlags[flagIndex] = {
    ...updateObject.props.featureFlags[flagIndex],
    active: enabled,
  };

  try {
    await mergeDocument(auth, tenantRef, updateObject);
  } catch (error) {
    console.error(`Error updating feature flag ${featureName}:`, error);
  }
};
